__turbopack_context__.v({
  "table": "Kwx7Oq_table",
  "td": "Kwx7Oq_td",
  "th": "Kwx7Oq_th",
});
